import type React from "react";
import Layout from "../../../../components/site/Layout/Layout";
import EventReportCard from "./components/EventReportCard";

// 仮のイベントレポートデータ
const eventReports = [
	{
		id: 1,
		title: "2023年4月のもくもく会レポート",
		date: "2023-04-15",
		summary:
			"今回のもくもく会では、10名の参加者が集まり、それぞれのプロジェクトに取り組みました。",
		imageUrl: "/images/event-report-1.jpg",
	},
	// 他のイベントレポートを追加
];

const EventReportPage: React.FC = () => {
	return (
		<Layout>
			<div className="w-full max-w-7xl mx-auto px-4 py-8 md:py-16">
				<h1 className="text-3xl font-bold text-center mb-8">
					イベントレポート
				</h1>
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
					{eventReports.map((report) => (
						<EventReportCard key={report.id} report={report} />
					))}
				</div>
			</div>
		</Layout>
	);
};

export default EventReportPage;
